module.exports = __webpack_public_path__ + "fonts/flaticon.ef0f6485.eot";